<template>
  <div>
    <b-card>
      <b-row>
        <h3 class="ml-2">Produtos</h3>
      </b-row>
      <b-row align-v="end"> 
        <b-col cold="8">
          <label for="">Produto</label>
          <b-form-input class="md-6" v-model="filtro.produto" placeholder="Código ou Nome"></b-form-input>
        </b-col>             
        
      </b-row>
      <b-row class="p-3">
        <b-table :items="tableData" :fields="colunas" show-empty hover striped :per-page="perPage" :filter="filtro.produto"
          :filter-included-fields="filterOn" stacked="md" @filtered="onFiltered" :current-page="currentPage">
          <template #cell(imagens)="row">
            <div v-if="row.value && row.value.length > 0 && row.value[0].path">
              <a href="#" @click="showImage(row.value)">
                <b-img :src="row.value[0].path" fluid style="width: 50px; height: 50px;"></b-img>
              </a>
            </div>
          </template>
        </b-table>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination fill class="mt-3" v-model="currentPage" :total-rows="tableData.length" :per-page="perPage"
            aria-controls="my-table"></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImagem" size="lg" hide-header>
      <b-carousel id="carousel-fade" fade indicators img-width="600" img-height="600" controls background="#C0C0C0"
        style="text-shadow: 1px 1px 2px #333;">
        <b-carousel-slide v-for="(imagem, index) in imagensModal" :key="index"
          style="max-width: 600px; max-height: 600px;">
          <template #img style="text-align: center;">
            <b-img class="text-center" :src="imagem.path" fluid-grow style="min-width: 600px; min-height: 600px;" />
          </template>
        </b-carousel-slide>
      </b-carousel>
      <template #modal-footer>
        <b-button variant="primary" class="float-right mr-2" size="sm" @click="modalImagem = false">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: [],
  data() {
    return {
      colunas: [
        { label: 'Código', key: 'codigo' },
        { label: 'Imagem', key: 'imagens' },
        { label: 'Produto', key: 'nome' },
        { label: 'Página', key: 'pagina' },
        { label: 'Preço R$', key: 'preco' },
      ],
      tableData: [],
      imagensModal: [],
      modalImagem: false,
      currentPage: 1,
      perPage: 20,
      filtro: {
        codigo: '',
        produto: ''
      },
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: ['nome', 'codigo'],
    };
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    showImage(imagens) {
      this.imagensModal = imagens.map((el) => {
        return { path: el.path }
      })
      this.modalImagem = true
    },
    loadProdutos() {
      const vm = this;
      $(".loading").show();
      axios("/distribuidor/produtos/list")
        .then((response) => {
          var data = [];
          response.data.forEach((item) => {
            let obj = {
              id: item.id,
              imagens: item.imagens,
              codigo: item.codigo,
              nome: item.nome,
              pagina: item.pivot.pagina,
              preco: item.pivot.preco.toString().replace(".", ",")
            };
            data.push(obj);
          });
          
          vm.tableData = data;
        })
        .catch((error) => {
          console.log('Aqui')
          alert("Falha ao carregar os produtos");
          $(".loading").hide();
          console.log(error);
        });
    }
  },  
  created() {
    this.loadProdutos();
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/produtos/Main.vue